export const TOTAL_ONBOARDING_STEPS = 15;

export const ONBOARDING_TARGETS = {
    sidebar: '[data-onboarding="sidebar"]',
    accountNavigation: '[data-onboarding="account-nav"]',
    topBar: '[data-onboarding="top-bar"]',
    workspaceControls: '[data-onboarding="workspace-controls"]',
    workspaceDropdown: '[data-onboarding="workspace-dropdown"]',
    addModule: '[data-onboarding="add-module"]',
    mainWorkspace: '[data-onboarding="main-workspace"]',
    accountOverview: '[data-onboarding="account-overview"]',
    accountDeposits: '[data-onboarding="account-deposits"]',
    accountWithdrawals: '[data-onboarding="account-withdrawals"]',
    accountBankAccounts: '[data-onboarding="account-bank-accounts"]',
    accountWallets: '[data-onboarding="account-wallets"]',
    security: '[data-onboarding="security"]',
    notifications: '[data-onboarding="notifications"]',
    otherFunctions: '[data-onboarding="other-functions"]',
    balances: '[id^="Balances-"]',
    orderForm: '[id^="Order-"]',
    tickers: '[id^="Tickers-"]',
    chart: '[id^="Chart-"]',
    orderBook: '[id^="Order Book-"]',
    blotter: '[id^="Blotter-"]',
    markets: '[id^="Markets-"]',
    accountValue: '[id^="Account Value-"]'
} as const;
